import { type FC } from "react";

import { LinkIcon, TextIcon } from "@snapchat/snap-design-system-icons";

import { type MyLensesLensCta } from "../../gql-generated/types";
import {
    LensDetailsPanelDisplay,
    LensDetailsPanelRow,
} from "../../submit/components/lens-details/shared/LensDetailsPanel.styles";
import { LensCtaTextLabelMap } from "../models";

import { LensCtaDeeplinkLink, LensCtaTextLabel, LensCtaWebsiteLabel } from "./messages.generated";

interface LensCtaProps {
    lensCta: MyLensesLensCta;
}

export const LensCtaDisplay: FC<LensCtaProps> = ({ lensCta }) => {
    return (
        <LensDetailsPanelDisplay>
            <LensDetailsPanelRow>
                <TextIcon /> <LensCtaTextLabel text={LensCtaTextLabelMap[lensCta.text]} />
            </LensDetailsPanelRow>

            <LensDetailsPanelRow>
                {lensCta.website && (
                    <>
                        <LinkIcon /> <LensCtaWebsiteLabel url={lensCta.website.url} />
                    </>
                )}
                {lensCta.deeplink && (
                    <>
                        <LinkIcon /> <LensCtaDeeplinkLink uri={lensCta.deeplink.uri} />
                    </>
                )}
            </LensDetailsPanelRow>
        </LensDetailsPanelDisplay>
    );
};
